import { animation, breakpoints, dimensions } from './variables';
import { css, SerializedStyles } from '@emotion/react';

import { fluidRange as polishedFluidRange } from 'polished';
export { css } from '@emotion/react';


/* --- animation helpers */

const transitionDefaultProperties = `transform, opacity, visibility`;

export const transitionDefault = css`
  transition: ${animation.fast}ms ease-out;
  transition-property: ${transitionDefaultProperties};
  will-change: ${transitionDefaultProperties};
`;

/* --- styling helpers */

export const absoluteFill = css`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

export const absoluteCenter = css`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

/* --- responsive helpers */

export const fluidRange = (
  prop: string,
  fromSize: string | number,
  toSize: string | number,

  minScreen?: number,
  maxScreen?: number
) => css`
  ${polishedFluidRange(
    { prop, fromSize, toSize },
    `${minScreen || breakpoints.sm}px`,
    `${maxScreen || breakpoints.max}px`
  )}
`;

export const respondFrom = (minW: number, content: SerializedStyles) => css`
  @media (min-width: ${minW}px) {
    ${content}
  }
`;

export const respondTo = (maxW: number, content: SerializedStyles) => css`
  @media (max-width: ${maxW - 1}px) {
    ${content}
  }
`;

export const calcEm = (size: number, fontSize: number): string =>
  `${size / fontSize}em`;
export const calcRem = (size: number): string =>
  `${size / dimensions.baseFontSize}rem`;
export const calcPerc = (size: number, containerSize: number): string =>
  `${(100 * size) / containerSize}%`;


/* 
  font-size based on vmin (smaller screen dimension)
  https://ryanfeigenbaum.com/easy-responsive-typography/ 
  adapted for vmin
*/
export const fluidFontSize = (
  min: number, max: number, minWBreakpoint: number = breakpoints.xs, maxWBreakpoint: number = breakpoints.max
) => {
  const minHBreakpoint = 300;
  const maxHBreakpoint = 1050;
  
  /* Define variable for fallback */
  const avg = (max + min) / 2;
  
  return css`
    /* Base font size */
    font-size: ${min}px;

    @media (min-width: ${minWBreakpoint}px) and (max-width: ${maxWBreakpoint - 1}px), 
      (min-height: ${minHBreakpoint}px) and (max-height: ${maxHBreakpoint - 1}px) {
        
        /* Adds a fallback for unsupported browsers */
        font-size: ${avg}px;
          
        /* The fluid typography magic 🌟  */
        font-size: calc(${min}px + (${max} - ${min}) * (100vmin - ${minWBreakpoint}px) / (${maxWBreakpoint} - ${minWBreakpoint}))
      
    }
    
    @media (min-width: ${maxWBreakpoint}px) and (min-height: ${maxHBreakpoint}px) {
        font-size: ${max}px;
    }
    
  `
}

/** -- other */

export const fontSmoothing = css`
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: antialiased;
  -o-font-smoothing: antialiased;
`;

export const unselectable = css`
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`


export const mixins = {
  transitionDefault,
  absoluteFill,
  absoluteCenter,
  
  fluidRange,
  respondFrom,
  respondTo,
  calcEm,
  calcRem,
  calcPerc,
  fluidFontSize,

  fontSmoothing,
  unselectable
};



// WEBPACK FOOTER //
// ./src/styles/mixins.ts